import { _, locale } from 'svelte-i18n';
import { get } from 'svelte/store';

// Read text without bootstrapping browser storage from transport/state modules.
export function getLocalizedText(key: string, defaultValue: string): string {
  return get(locale) ? get(_)(key, { default: defaultValue }) : defaultValue;
}
